import { render, staticRenderFns } from "./BiodigestorCyclesWidgetComponent.vue?vue&type=template&id=7f2dcf6c&"
import script from "./BiodigestorCyclesWidgetComponent.vue?vue&type=script&lang=js&"
export * from "./BiodigestorCyclesWidgetComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports